// extracted by mini-css-extract-plugin
export default {"textBox":"AuthForms_textBox__rIIcf","button":"AuthForms_button__9Mcaw"};